export function imageUrl (imageId) {
    return `/api/Images/${imageId}`
}
